import { render, staticRenderFns } from "./activeFormatProjects.vue?vue&type=template&id=081ffebe&"
import script from "./activeFormatProjects.vue?vue&type=script&lang=js&"
export * from "./activeFormatProjects.vue?vue&type=script&lang=js&"
import style0 from "./activeFormatProjects.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports